/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaricoRiscontroUpdateDTO
 */
export interface CaricoRiscontroUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof CaricoRiscontroUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof CaricoRiscontroUpdateDTO
     */
    peso?: number;
    /**
     * 
     * @type {number}
     * @memberof CaricoRiscontroUpdateDTO
     */
    capi?: number;
    /**
     * 
     * @type {number}
     * @memberof CaricoRiscontroUpdateDTO
     */
    idCategoriaCarico?: number | null;
}

/**
 * Check if a given object implements the CaricoRiscontroUpdateDTO interface.
 */
export function instanceOfCaricoRiscontroUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CaricoRiscontroUpdateDTOFromJSON(json: any): CaricoRiscontroUpdateDTO {
    return CaricoRiscontroUpdateDTOFromJSONTyped(json, false);
}

export function CaricoRiscontroUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaricoRiscontroUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'peso': !exists(json, 'peso') ? undefined : json['peso'],
        'capi': !exists(json, 'capi') ? undefined : json['capi'],
        'idCategoriaCarico': !exists(json, 'idCategoriaCarico') ? undefined : json['idCategoriaCarico'],
    };
}

export function CaricoRiscontroUpdateDTOToJSON(value?: CaricoRiscontroUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoAnimale': value.idTipoAnimale,
        'peso': value.peso,
        'capi': value.capi,
        'idCategoriaCarico': value.idCategoriaCarico,
    };
}

